export default __webpack_public_path__ + "static/media/fondo.9f888974.png";